<template>
  <page-wrapper
    :isLoading="isLoading"
    :hasFilters="true"
    @submitFilters="setPageNumberAndFilters"
  >
    <template #title> لیست اساتید نظرسنجی شده </template>
    <template #filters>
      <search-input
        inputId="searchCommand"
        inputLabel="جستجوی نام استاد"
        inputPlaceholder="امیر..."
        :inputValue="reportsListFilter.search"
        v-model="reportsListFilter.search"
        @enter="setPageNumberAndFilters"
      ></search-input>
      <custom-select
        class="w-24 filters-width"
        inputId="rateFilter"
        inputLabel="مرتب سازی"
        :customOptions="rateFilterOptions"
        @getSelectedOption="setRateFilter"
      ></custom-select>
    </template>
    <custom-table
      v-if="reportsList && reportsList.length"
      :pageNumber="reportsListFilter.pageNumber"
      :count="reportsListFilter.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="reportsList"
      @changePage="changePage"
      ref="reportsListRef"
    >
      <template #cellDetails="data">
        <BRow>
          <BCol cols="3">
            <p class="font-weight-bolder">عنوان</p>
          </BCol>
          <BCol cols="3">
            <p class="font-weight-bolder">شرکت کننده ها</p>
          </BCol>
          <BCol cols="3">
            <p class="font-weight-bolder">میانگین رتبه استاد</p>
          </BCol>
          <BCol cols="3">
            <p class="font-weight-bolder">جزئیات</p>
          </BCol>
          <BCol cols="12" class="mt-0">
            <hr class="mt-0" />
          </BCol>
          <BCol
            cols="12"
            v-for="(survey, index) in data.item.data"
            :key="index"
          >
            <BRow class="custom-inner-table-bg-color rounded-sm py-1">
              <BCol cols="3" class="px-2">
                <p class="mb-0">
                  {{ survey.surveyTitle }}
                </p>
              </BCol>
              <BCol cols="3" class="px-2">
                <p class="mb-0">
                  {{ survey.count }}
                </p>
              </BCol>
              <BCol cols="3" class="px-2">
                <p class="mb-0">
                  {{ survey.rateAVG ? survey.rateAVG.toFixed(2) : 0 }}
                </p>
              </BCol>
              <BCol cols="3" class="px-2">
                <b-link
                  :to="`/apps/surveys/reports/${data.item.masterUserId}/${survey.surveyId}`"
                >
                  <feather-icon
                    size="20"
                    icon="ExternalLinkIcon"
                  ></feather-icon>
                </b-link>
              </BCol>
            </BRow>
            <hr />
          </BCol>
        </BRow>
      </template>
      <template #rateAVGTotal="data">
        {{ data.item.rateAVGTotal ? data.item.rateAVGTotal.toFixed(2) : 0 }}
      </template>
      <template #actions="data">
        <!-- /apps/surveys/reports/masterid/surveyid -->
        <BButton
          size="sm"
          variant="success"
          @click="renderRowDetails(data.index)"
        >
          نمایش جزئیات
        </BButton>
      </template>
    </custom-table>
  </page-wrapper>
</template>
<script>
import { GetReportOfMasterSurveys } from "@/libs/Api/SuveyUserSurvey";
export default {
  mounted() {
    if (this.computedPageRouteQuery) {
      this.reportsListFilter.pageNumber = this.computedPageRouteQuery;
    } else {
      this.reportsListFilter.pageNumber = 1;
    }
    this.getMasterSurveyReportList();
  },
  data() {
    return {
      isLoading: false,
      reportsList: null,
      totalCount: null,
      reportsListFilter: {
        count: 10,
        pageNumber: 1,
        search: null,
        surveyId: null,
        // 1 is for ascending
        // 2 is for descending
        rateFilter: 1,
      },
      myTableColumns: [
        {
          key: "masterName",
          label: "نام استاد",
        },
        {
          key: "particepenCount",
          label: "تعداد شرکت کنندگان",
        },
        {
          key: "rateAVGTotal",
          label: "میانگین رتبه استاد",
        },
        {
          key: "actions",
          label: "جزئیات",
        },
      ],
      rateFilterOptions: [
        {
          value: null,
          text: "از جدید ترین",
        },
        {
          value: 1,
          text: "از کم ترین رتبه",
        },
        {
          value: 2,
          text: "از بیشترین رتبه",
        },
      ],
    };
  },
  methods: {
    async getMasterSurveyReportList() {
      try {
        this.isLoading = true;

        let _this = this;
        let getReportOfMasterSurveys = new GetReportOfMasterSurveys(_this);
        getReportOfMasterSurveys.setRequestParam(_this.reportsListFilter);
        await getReportOfMasterSurveys.fetch((res) => {
          if (res.isSuccess) {
            _this.reportsList = res.data.masterDetials;
            _this.totalCount = res.data.totalCount;
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "AlertCircleIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد!",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderRowDetails(rowIndex) {
      if (this.$refs.reportsListRef) {
        this.$refs.reportsListRef.showRowDetails(rowIndex);
      }
    },
    setPageNumberAndFilters() {
      this.reportsListFilter.pageNumber = 1;
      this.getMasterSurveyReportList();
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: pageNumber,
        },
      });
    },
    setRateFilter(selectedRate) {
      this.reportsListFilter.rateFilter = selectedRate;
    },
    changePage(pageNumber) {
      this.reportsListFilter.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getMasterSurveyReportList();
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.page) {
        return this.$route.query.page;
      }
      return null;
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BPagination,
    BOverlay,
    ToastificationContent,
    PageWrapper,
    CustomTable,
    SearchInput,
    CustomSelect,
  },
};
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
<style>
.custom-inner-table-bg-color {
  background-color: #ebebeb !important;
}
</style>
